"use client";

import { cn } from "@/shared/lib/utils";
import { Provider, Root, Trigger, Content, Portal } from "@radix-ui/react-tooltip";
import { forwardRef, type ElementRef, type ComponentPropsWithoutRef } from "react";


const TooltipProvider = Provider;

const Tooltip = Root;

const TooltipTrigger = Trigger;

const TooltipContent = forwardRef<
  ElementRef<typeof Content>,
  ComponentPropsWithoutRef<typeof Content>
>(({ className, sideOffset = 4, ...properties }, reference) => (
  <Portal>
    <Content
      ref={reference}
      sideOffset={sideOffset}
      className={cn(
        "z-50 overflow-hidden rounded-lg border border-border/60 bg-popover/95 backdrop-blur-sm px-4 py-3 text-sm leading-relaxed text-popover-foreground shadow-[0_0_0_1px_hsl(var(--border)/0.05),0_8px_16px_-4px_rgb(0_0_0/0.12),0_4px_6px_-2px_rgb(0_0_0/0.08)] dark:shadow-[0_0_0_1px_hsl(var(--border)/0.05),0_8px_16px_-4px_rgb(0_0_0/0.4),0_4px_6px_-2px_rgb(0_0_0/0.3)] dark:ring-1 dark:ring-white/5 animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className
      )}
      {...properties}
    />
  </Portal>
));
TooltipContent.displayName = Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
